import React from 'react';
import TypeDesktopItem from '../dropdowns/typeDesktopItem';
import { CONGRESS_COMMUNITIES } from '../../../constants';

const CategoryType = ({ chooseDropdownType, congress, all, selectedItem }) => {

    let filteredOrgs = [];

    if (typeof all != 'undefined') {

        const { selected } = congress;
        const { abrvState, districtName, district, } = selected;

        filteredOrgs = all
            .filter(org => (abrvState === 'US') ? true : (org.properties.state === abrvState))
            .filter((org) => (districtName === 'District') ? true : (org.properties.congress_district === (abrvState + district)));
    }

    return CONGRESS_COMMUNITIES.map(({ id, name, color, alt_name }) =>
        <div className="category-filter" key={id}>
            <div className="category-spacer"/>
            <TypeDesktopItem
                key={id}
                id={id}
                name={name}
                alt_name={alt_name}
                color={color}
                func={chooseDropdownType}
                filteredOrgs={filteredOrgs}
                selectedItem={selectedItem}
                desktopSelectedCat={congress.selected.categoryName}
            />
        </div>,
    );

};

export default CategoryType;
